import AuthStore from "./AuthStore";

const authStore: AuthStore = new AuthStore();
export default authStore;
